<template>
  <div>
    <v-row class="px-5">
      <v-col>
        <VFileDragAndDrop
          :file="analysisParameters"
          :mimes="acceptedFileMimetype.JSON"
          :loading="uploadFileLoading"
          :disabled="isNotAllowed"
          @onChange="onDragAndDropChange"
        />
      </v-col>
    </v-row>
    <v-row
      v-if="fileExist"
      class="px-10"
    >
      <UploadedBackendFiles
        :backendFiles="files"
        type="appendix"
        :disabled="isNotAllowed"
        :forceDisableRemove="true"
        :onDownloadFile="handleDownloadFile"
        v-on="$listeners"
      />
    </v-row>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { isEmpty } from 'lodash';
import acceptedFileMimetype from '@/constants/acceptedFileMimetype';
import VFileDragAndDrop from '@/components/shared/widgets/forms/VuetifyInputs/VFileDragAndDrop';
import UploadedBackendFiles from '@/components/shared/UploadedBackendFiles.vue';

export default ({
    components: {
        VFileDragAndDrop,
        UploadedBackendFiles,
    },
    data() {
        return {
            uploadFileLoading: false,
            analysisParameters: null,
            fileExist: false,
            files: [],
        };
    },
    computed: {
        ...mapGetters([
            'hasPermission',
            'superAdmin',
        ]),
        acceptedFileMimetype() {
            return acceptedFileMimetype;
        },
        isNotAllowed() {
            return !this.superAdmin && !this.hasPermission('files.add');
        },
    },
    async created() {
        this.getAnalysisParameters();
    },
    methods: {
        async getAnalysisParameters() {
            const config = {
                params: {
                    responseType: 'content',
                    path: 'mobile/analysisParameters.json',
                },
            };
            const response = await this.$rq.getS3File(config);
            if (response?.data?.jsonObject && !isEmpty(response.data.jsonObject)) {
                this.files = [{ title: 'Analysis parameters.json' }];
                this.fileExist = true;
            } else {
                this.fileExist = false;
            }
        },
        async handleDownloadFile() {
            const config = {
                params: {
                    responseType: 'blob',
                    path: 'mobile/analysisParameters.json',
                },
                responseType: 'blob',
            };
            const response = await this.$rq.getS3File(config);
            this.$utils.saveFileOnDisk(response.data, 'analysisParameters.json');
            this.$toasted.global.toast_success({
                message: this.$t('toastMessage.defaultSuccess'),
            });
        },
        async onDragAndDropChange(file) {
            try {
                this.uploadFileLoading = true;
                const formData = new FormData();
                formData.append('file', file);
                formData.append('path', 'mobile/analysisParameters.json');
                await this.$rq.storeS3File(null, formData);
                this.$toasted.global.toast_success({
                    message: this.$t('toastMessage.defaultSuccess'),
                });
                this.uploadFileLoading = false;
            } catch (error) {
                this.uploadFileLoading = false;
            }
        },
    },
});
</script>
